export default {
  checked: false,
  logged: false
};
